// extracted by mini-css-extract-plugin
export var carouselPane = "WhyChooseUs--carouselPane--Ngl9D";
export var carouselPane__left = "WhyChooseUs--carouselPane__left--l3AYJ";
export var carouselPane__right = "WhyChooseUs--carouselPane__right--zWp8i";
export var tkMyriadProSemiCondensed = "WhyChooseUs--tk-myriad-pro-semi-condensed--S8RFc";
export var whyChooseUs = "WhyChooseUs--whyChooseUs--wmOAR";